/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataReturnOrderGoodsDto } from './NodataReturnOrderGoodsDto';
import {
    NodataReturnOrderGoodsDtoFromJSON,
    NodataReturnOrderGoodsDtoFromJSONTyped,
    NodataReturnOrderGoodsDtoToJSON,
    NodataReturnOrderGoodsDtoToJSONTyped,
} from './NodataReturnOrderGoodsDto';

/**
 * 
 * @export
 * @interface NodataReturnOrderResVo
 */
export interface NodataReturnOrderResVo {
    /**
     * 生成的返送订单ID
     * @type {number}
     * @memberof NodataReturnOrderResVo
     */
    id?: number;
    /**
     * 生成的返送订单编号
     * @type {string}
     * @memberof NodataReturnOrderResVo
     */
    code?: string;
    /**
     * 绑定快递包裹的实际入库进程：1待入库、2已签收、3已入库；绑定缺失时为空
     * @type {number}
     * @memberof NodataReturnOrderResVo
     */
    parcelStatus?: number;
    /**
     * 绑定快递包裹的入库进程名称，按当前语言返回
     * @type {string}
     * @memberof NodataReturnOrderResVo
     */
    parcelStatusName?: string;
    /**
     * 当前无数据包裹ID
     * @type {number}
     * @memberof NodataReturnOrderResVo
     */
    nodataId?: number;
    /**
     * 是否已提交返送订单；成功和重复提交均为true，页面关闭商品编辑和提交入口
     * @type {boolean}
     * @memberof NodataReturnOrderResVo
     */
    returnOrderSubmitted?: boolean;
    /**
     * 已生成返送订单的商品快照及本次申请数量，可直接替换页面商品列表；共用包裹入库进程
     * @type {Array<NodataReturnOrderGoodsDto>}
     * @memberof NodataReturnOrderResVo
     */
    goods?: Array<NodataReturnOrderGoodsDto>;
}

/**
 * Check if a given object implements the NodataReturnOrderResVo interface.
 */
export function instanceOfNodataReturnOrderResVo(value: object): value is NodataReturnOrderResVo {
    return true;
}

export function NodataReturnOrderResVoFromJSON(json: any): NodataReturnOrderResVo {
    return NodataReturnOrderResVoFromJSONTyped(json, false);
}

export function NodataReturnOrderResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataReturnOrderResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'parcelStatus': json['parcelStatus'] == null ? undefined : json['parcelStatus'],
        'parcelStatusName': json['parcelStatusName'] == null ? undefined : json['parcelStatusName'],
        'nodataId': json['nodataId'] == null ? undefined : json['nodataId'],
        'returnOrderSubmitted': json['returnOrderSubmitted'] == null ? undefined : json['returnOrderSubmitted'],
        'goods': json['goods'] == null ? undefined : ((json['goods'] as Array<any>).map(NodataReturnOrderGoodsDtoFromJSON)),
    };
}

export function NodataReturnOrderResVoToJSON(json: any): NodataReturnOrderResVo {
    return NodataReturnOrderResVoToJSONTyped(json, false);
}

export function NodataReturnOrderResVoToJSONTyped(value?: NodataReturnOrderResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'parcelStatus': value['parcelStatus'],
        'parcelStatusName': value['parcelStatusName'],
        'nodataId': value['nodataId'],
        'returnOrderSubmitted': value['returnOrderSubmitted'],
        'goods': value['goods'] == null ? undefined : ((value['goods'] as Array<any>).map(NodataReturnOrderGoodsDtoToJSON)),
    };
}

